import React, { useCallback, useContext, useMemo } from 'react';
import { Stage, Layer } from 'react-konva';
import block from 'bem-cn';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { ThemeContext, ThemeProvider } from 'services/theme';
import { actions as gameActions } from 'features/Game';

import Pyramid from './Pyramid';

import './GameView.scss';
import { Provider } from 'react-redux';

const b = block('game-view');

const GameView = ({ canvasParam }) => {
    const dispatch = useDispatch();

    const endGameHandler = useCallback(game => {
        dispatch(gameActions.endGame(game));
    }, [dispatch]);

    const { activeBalls, coefficients, gameSettings } = useSelector(state => state.game);
    const { rowsCount } = useSelector(state => state.game.gameSettings);

    const needCoefficients = useMemo(() => coefficients?.[gameSettings.riskLevel]?.[gameSettings.rowsCount] || [], [coefficients, gameSettings]);

    const themeContext = useContext(ThemeContext);
    const store = useStore();
    
    return (
        <Stage className={b()} width={canvasParam.width} height={canvasParam.height}>
            <Provider store={store}>
                <ThemeProvider themeMap={themeContext.themeMap}>
                    <Layer x={0} y={0}>
                        <Pyramid
                            coeffs={needCoefficients}
                            height={rowsCount}
                            widthCanvas={canvasParam.width}
                            heightCanvas={canvasParam.height}
                            activeBalls={activeBalls}
                            onEndGame={endGameHandler}
                        />
                    </Layer>
                </ThemeProvider>
            </Provider>
        </Stage>
    )
};

export default GameView;